/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown>, days: NonNullable<unknown> }} Sharerulesdetail2Inputs */

const en_sharerulesdetail2 = /** @type {(inputs: Sharerulesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Credited after ${i?.hours} hours, valid for ${i?.days} days, only for AI features, no cash value. A visit counts once per device, a plan only from registered users.`)
};

const de_sharerulesdetail2 = /** @type {(inputs: Sharerulesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gutschrift nach ${i?.hours} Stunden, gültig ${i?.days} Tage, nur für KI-Funktionen, ohne Geldwert. Ein Besuch zählt einmal pro Gerät, ein Plan nur von angemeldeten Personen.`)
};

/**
* | output |
* | --- |
* | "Credited after {hours} hours, valid for {days} days, only for AI features, no cash value. A visit counts once per device, a plan only from registered users." |
*
* @param {Sharerulesdetail2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharerulesdetail2 = /** @type {((inputs: Sharerulesdetail2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharerulesdetail2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharerulesdetail2(inputs)
	return de_sharerulesdetail2(inputs)
});
export { sharerulesdetail2 as "shareRulesDetail" }